import { api } from "../api";

/**
 * API service para gerenciar conexões WhatsApp Evolution API
 * Seguindo padrão arquitetural do projeto JBE Engenharia
 */

// Listar todas as conexões
export const getWhatsAppConnections = async () => {
  const url = "/whatsapp/connections";
  return await api.get(url);
};

// Conectar instância (retorna QR Code)
export const connectWhatsAppInstance = async (connectionId) => {
  const url = "/whatsapp/evolution/connect";
  const body = connectionId ? { connectionId } : {};
  return await api.post(url, body);
};

// Desconectar instância
export const disconnectWhatsAppInstance = async (connectionId) => {
  const url = "/whatsapp/evolution/disconnect";
  const body = connectionId ? { connectionId } : {};
  return await api.post(url, body);
};

// Reiniciar instância
export const restartWhatsAppInstance = async (connectionId) => {
  const url = "/whatsapp/evolution/restart";
  const body = connectionId ? { connectionId } : {};
  return await api.post(url, body);
};

// Legacy function - mantém compatibilidade
export const getWhatsAppStatus = getWhatsAppConnections; 